import { render } from "./MainDiscountGlobal.vue?vue&type=template&id=ff511fd8&scoped=true"
import script from "./MainDiscountGlobal.vue?vue&type=script&lang=js"
export * from "./MainDiscountGlobal.vue?vue&type=script&lang=js"

import "./MainDiscountGlobal.vue?vue&type=style&index=0&id=ff511fd8&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff511fd8"]])

export default __exports__